import { Field } from "formik";
import React from "react";
import { FormHelperText } from "@mui/material";
import DropdownMenu from "./DropdownMenu";

const Dropdown2 = ({ selected, handleChange, options, elementName, ...props }) => {
  return (
    <>
      <Field name={elementName}>
        {({ field, form, meta }) => (
          <>
            <DropdownMenu
              value={selected}
              onChangeAction={handleChange}
              elementName={elementName}
              options={options}
              {...props}
            />
            {meta.error && (
              <FormHelperText error id={`${elementName}-error`}>
                {meta.error}
              </FormHelperText>
            )}
          </>
        )}
      </Field>
    </>
  );
};

export default Dropdown2;
